export default {
  menus: {
    core: 'Core',
    general: 'General',
    dashboard: 'Dashboard',
    user: 'User',
    settings: 'Settings',
    devices: 'Devices',
    userDescription: 'Manage users',
    settingsDescription: 'Application settings',
    devicesDescription: 'Manage devices activated with your account',
  },
  routeTitles: {
    home: 'Home',
    user: 'User',
    settings: 'Settings',
    devices: 'Devices',
    billingSuccess: 'Payment Successful',
    login: 'Login',
    register: 'Register',
    forgotPassword: 'Forgot Password',
    resetPassword: 'Reset Password',
    legal: 'Legal',
    subscribe: 'Subscribe',
    notFound: 'Page Not Found',
  },
  common: {
    orContinueWith: 'Or continue with',
    google: 'Google',
    copyright: 'All rights reserved.',
    language: 'Language',
    toggleTheme: 'Toggle theme',
    pages: 'Pages',
    inThisPage: 'In This Page',
    english: 'English',
    chinese: '中文',
    backToSignIn: 'Back to sign in',
    close: 'Close',
    download: 'Download',
    profile: 'Profile',
    logout: 'Log out',
    searchPlaceholder: 'Search...',
    support: 'Support',
    emailSupport: 'Email support',
  },
  auth: {
    welcomeBack: 'Welcome back',
    sessionExpired: 'Your session has expired — please log in again.',
    signInToWorkspace: 'Sign in to GEEKFUN Data Studio',
    email: 'Email address',
    emailPlaceholder: "name{'@'}company.com",
    password: 'Password',
    passwordPlaceholder: '••••••••',
    verificationCode: 'Verification Code',
    codePlaceholder: '000000',
    sendCode: 'Send Code',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    useVerificationCode: 'Use verification code',
    usePassword: 'Use password',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    signIn: 'Sign in to GEEKFUN',
    dontHaveAccount: "Don't have an account?",
    signUpFree: 'Sign up for free',
    newToGeekfun: 'New to GEEKFUN?',
    signUpValue: 'Free forever plan · 7-day Ultimate trial',
    signUp: 'Sign Up',
    passwordRequired: 'Password is required',
    codeRequired: 'Verification code is required',
    googleSignInFailed: 'Google sign-in failed. Please try again.',
    googleSignInNotCompleted: 'Google Sign-In was not completed. Please try again.',
    createAccount: 'Create your account',
    joinGeekfun: 'Join GEEKFUN and start managing your data',
    fullName: 'Full Name',
    fullNamePlaceholder: 'John Doe',
    passwordMinLength: 'Must be at least 8 characters',
    agreeToTerms: 'I agree to the',
    terms: 'Terms',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    byClickingContinue: 'By clicking to continue, you agree to our ',
    createAccountButton: 'Create Account',
    creatingAccount: 'Creating account…',
    alreadyHaveAccount: 'Already have an account?',
    logIn: 'Log in',
    fullNameRequired: 'Full name is required',
    validEmailRequired: 'Please enter a valid email address',
    passwordMin8: 'Password must be at least 8 characters',
    codeSentToEmail: 'Verification code sent to your email',
    emailRequiredFirst: 'Please enter a valid email address first',
    failedSendCode: 'Failed to send verification code. Please try again.',
    mustAgreeTerms: 'You must agree to the Terms and Privacy Policy',
    registrationFailed: 'Registration failed. Please try again.',
    mustAgreeTermsBeforeContinue:
      'You must agree to the Terms and Privacy Policy before continuing',
    googleRegistrationFailed: 'Google registration failed. Please try again.',
    forgotPasswordTitle: 'Forgot password?',
    forgotPasswordDesc:
      "Enter the email address associated with your account and we'll send you a password reset link.",
    resetLinkSent:
      'If an account exists for this email, a reset link has been sent. Please check your inbox.',
    sendResetLink: 'Send reset link',
    sendAgain: 'Send again',
    validatingResetLink: 'Validating your reset link...',
    linkExpiredOrInvalid: 'Link expired or invalid',
    linkExpiredDesc:
      'This password reset link is invalid or has expired. Please request a new one.',
    requestNewResetLink: 'Request a new reset link',
    linkAlreadyUsed: 'Link already used',
    linkAlreadyUsedDesc:
      'This password reset link has already been used. If you need to reset your password again, please request a new link.',
    passwordReset: 'Password reset!',
    passwordResetSuccess: 'Your password has been reset successfully.',
    signInWithNewPassword: 'Sign in with new password',
    setNewPassword: 'Set new password',
    chooseStrongPassword: 'Choose a strong password with at least 8 characters.',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    resetPassword: 'Reset password',
    passwordsDoNotMatch: 'Passwords do not match',
    somethingWentWrong: 'Something went wrong. Please try again.',
    resetLinkAlreadyUsed: 'This reset link has already been used. Please request a new one.',
    requestNewResetLinkError: 'Something went wrong. Please request a new reset link.',
    loginFailed: 'Account does not exist or password is incorrect, please try again',
  },
  handoff: {
    loginSuccessful: 'Login Successful!',
    accountReady: 'Your account is ready. Would you like to open {app}?',
    continueToWeb: 'Continue to Web',
    openInApp: 'Open in {app}',
  },
  brand: {
    name: 'GEEKFUN Data Studio',
    tagline: 'Professional data management suite for high-performance teams.',
  },
  dockitBrand: {
    name: 'DocKit',
    tagline: 'NoSQL client for Elasticsearch, OpenSearch, and DynamoDB.',
  },
  sqlkitBrand: {
    name: 'SqlKit',
    tagline: 'SQL client for PostgreSQL, MySQL, SQL Server, and more.',
  },
  legal: {
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    refundPolicy: 'Refund Policy',
    consentRequired: 'Consent Required',
    consentDescription:
      'Before creating your account, please review and accept our legal policies.',
    consentSummary: 'By agreeing, you acknowledge that you have read and accept:',
    consentItem1: 'How we collect and use your personal information',
    consentItem2: 'Your rights regarding your data',
    consentItem3: 'Terms governing your use of our services',
    agreeAndContinue: 'Agree & Continue',
    decline: 'Decline',
  },
  profile: {
    title: 'Profile',
    avatar: 'Avatar',
    avatarDescription: 'Your profile picture',
    changeAvatar: 'Change',
    removeAvatar: 'Remove',
    avatarConstraints: 'JPEG, PNG or WebP. Max 2MB.',
    information: 'Profile Information',
    informationDescription: 'Update your profile details',
    username: 'Username',
    usernamePlaceholder: 'johndoe',
    usernameDescription: '3-30 characters, letters, numbers and underscores only.',
    fullName: 'Full Name',
    fullNamePlaceholder: 'John Doe',
    email: 'Email',
    emailDescription: 'Email cannot be changed.',
    saveChanges: 'Save Changes',
    updateSuccess: 'Profile updated successfully!',
    validation: {
      usernameMin: 'Username must be at least 3 characters',
      usernameMax: 'Username must be at most 30 characters',
      usernamePattern: 'Username can only contain letters, numbers and underscores',
      fullNameMax: 'Full name must be at most 100 characters',
      avatarTooLarge: 'Image size must be less than 2MB',
      avatarInvalidType: 'Image must be JPEG, PNG or WebP format',
    },
  },
  settings: {
    title: 'Settings',
    security: 'Security',
    preferences: 'Preferences',
    notifications: 'Notifications',
    changePassword: 'Change Password',
    changePasswordDescription: 'Update your password to keep your account secure',
    currentPassword: 'Current Password',
    currentPasswordPlaceholder: '••••••••',
    newPassword: 'New Password',
    newPasswordPlaceholder: '••••••••',
    newPasswordDescription: 'At least 8 characters',
    confirmPassword: 'Confirm Password',
    confirmPasswordPlaceholder: '••••••••',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    passwordChanged: 'Password changed successfully!',
    displayPreferences: 'Display Preferences',
    displayPreferencesDescription: 'Customize how the application looks and feels',
    language: 'Language',
    selectLanguage: 'Select language',
    theme: 'Theme',
    selectTheme: 'Select theme',
    themeSystem: 'System',
    themeLight: 'Light',
    themeDark: 'Dark',
    preferencesSaved: 'Preferences saved successfully!',
    emailNotifications: 'Email Notifications',
    emailNotificationsDescription: 'Manage your email notification preferences',
    emailNotificationsLabel: 'Email Notifications',
    emailNotificationsDescription2: 'Receive emails about account activity and updates',
    marketingEmails: 'Marketing Emails',
    marketingEmailsDescription: 'Receive emails about new features and promotions',
    notificationsSaved: 'Notification settings saved!',
    saveChanges: 'Save Changes',
    changePasswordFailed: 'Failed to change password',
    saveFailed: 'Failed to save settings',
    dangerZone: 'Danger Zone',
    deleteAccount: 'Delete this account',
    deleteAccountDescription:
      'Once you delete your account, there is no going back. Please be certain. This permanently removes your profile, subscriptions, transaction history, trials and personal data.',
    deleteConfirmTitle: 'Delete Account?',
    deleteConfirmDescription:
      'This will permanently delete your account, subscriptions, transactions, trials and personal data. If you have an active subscription, cancel it first.',
    deleteTypeConfirm: "Type 'DELETE' to confirm",
    deleteFailed: 'Failed to delete account',
    validation: {
      currentPasswordRequired: 'Current password is required',
      newPasswordMin: 'New password must be at least 8 characters',
      passwordsMatch: 'Passwords do not match',
    },
  },
  subscribe: {
    title: 'GEEKFUN Data Studio Ultimate',
    status: {
      checking: 'Checking your subscription...',
      checkout: 'Opening secure payment...',
      trial: 'Starting your free trial...',
    },
    changePlan: 'Change plan',
    continueToPayment: 'Continue to payment',
    goToDashboard: 'Go to Dashboard',
    trialUsed: {
      title: 'Free trial already used',
      description:
        'Your 7-day free trial has already been used on this account. Subscribe to keep using all Ultimate features.',
      subscribeCta: 'Subscribe Now',
    },
    errors: {
      title: 'Unable to continue',
      loadFailed: 'We could not load your subscription status. Please try again.',
      checkoutFailed: 'We could not open the checkout. Please try again.',
      trialFailed: 'We could not start your free trial. Please try again.',
      retry: 'Try Again',
    },
  },
  billing: {
    title: 'Billing & Subscription',
    description: 'Manage your subscription and view transaction history',
    notAvailable: 'N/A',
    mor: {
      creem: 'Payments are processed by Creem (Armitage Labs OÜ), our Merchant of Record, which handles payment collection, tax compliance, invoices, and refunds.',
      waffo: 'Payments are processed by Waffo (Waffo.com Limited, HK), our Merchant of Record, which handles payment collection, tax compliance, invoices, and refunds.',
    },
    trial: {
      title: 'Free Trial',
      description: 'Your 7-day free trial of Ultimate',
      trialEnd: 'Trial Ends',
      cancelTrial: 'Cancel Trial',
      canceling: 'Canceling...',
      subscribe: 'Subscribe Now',
      canceled: 'Trial Canceled',
      cancelConfirmTitle: 'Cancel Free Trial?',
      cancelConfirmDescription: 'Are you sure you want to cancel your free trial?',
      cancelConfirmWarning: 'You will lose access to all Ultimate features immediately.',
      keepTrial: 'Keep Trial',
      confirmCancel: 'Cancel Trial',
    },
    plan: {
      community: 'Community',
      ultimate: 'Ultimate',
      free: 'Free',
    },
    status: {
      pending: 'Pending Payment',
      trialing: 'On Trial',
      active: 'Active',
      past_due: 'Past Due',
      canceled: 'Canceled',
      expired: 'Expired',
    },
    billing: {
      monthly: 'Monthly',
      yearly: 'Yearly',
      month: 'month',
      year: 'year',
    },
    details: {
      amount: 'Amount',
      nextBilling: 'Next Billing',
      trialEnd: 'Trial Ends',
      accessUntil: 'Access Until',
    },
    actions: {
      loading: 'Loading...',
      managePayment: 'Manage Payment',
      completePayment: 'Complete Payment',
      cancelSubscription: 'Cancel Subscription',
    },
    support: {
      cny: 'To change this CNY plan, email support.',
      failed:
        'Billing updated at the payment provider but not here. Email support and we will fix it.',
    },
    transactions: {
      title: 'Transaction History',
      description: 'View your payment history',
      empty: 'No transactions yet',
      charge: 'Payment',
      refund: 'Refund',
      status: {
        success: 'Success',
        failed: 'Failed',
        pending: 'Pending',
      },
    },
    cancel: {
      title: 'Cancel Subscription?',
      description: 'Are you sure you want to cancel your subscription?',
      warning: 'You will retain access until {date}. After that, your subscription ends.',
      refundPolicy:
        'Payments are non-refundable because a 7-day free trial is offered before any charge. See our Refund Policy for details and exceptions.',
      scheduledTitle: 'Cancellation scheduled',
      scheduledNotice:
        'Your subscription will end on {date} and will not renew. You keep full access until then.',
      accessUntilNotice: 'Your subscription is canceled. You have access until {date}.',
      back: 'Keep Subscription',
      confirm: 'Cancel Subscription',
      canceling: 'Canceling...',
    },
    noSubscription: {
      title: 'No Active Subscription',
      description:
        "You don't have an active subscription yet. Upgrade to Ultimate to access all premium features.",
      cta: 'Subscribe Now',
    },
    success: {
      title: 'Payment Successful!',
      description: 'Thank you for subscribing to GEEKFUN Data Studio Ultimate.',
      verifying: 'Verifying your payment...',
      errorTitle: 'Verification Failed',
      invalidRedirect: 'Invalid redirect. Please check your billing status.',
      activationPending:
        'Your payment may still be processing. If you were charged, your subscription will activate shortly. Check the Billing page in a few minutes.',
      whatHappensNext: 'What happens next:',
      trialStarted: 'Your 7-day free trial has started',
      fullAccess: 'You now have full access to all Ultimate features',
      manageBilling: 'You can manage your subscription anytime from the Billing page',
      goToDashboard: 'Go to Dashboard',
      viewBilling: 'View Billing',
      goToBilling: 'Go to Billing',
    },
  },
  dashboard: {
    subscription: 'Subscription',
    quickLaunch: 'Quick Launch',
    snippets: 'Code Snippets',
    aiAssistants: 'AI Assistants',
    files: 'Files',
    connections: 'Connections',
    trendFromLastMonth: '+0% from last month',
    trendSinceLastHour: '+0 since last hour',
    comingSoon: 'Coming soon',
    upgrade: 'Upgrade to Ultimate',
    manage: 'Manage Subscription',
    trialDaysLeft: '{days} days left in trial',
    choosePlan: 'Choose billing period',
    savePercent: 'Save {percent}%',
    pendingCheckoutHint: 'Your last checkout is still awaiting payment — you can finish it anytime.',
    startNewCheckout: 'Start a new checkout',
    unlockLabel: 'Unlock with Ultimate',
    featureAi: 'AI Assistant — custom agents & LLM keys across DocKit & SqlKit',
    featureNl2sql: 'AI NL2SQL — natural language to SQL & PartiQL',
    featureAgent: 'Data Studio Agent — your databases, in plain language',
    featureMcp: 'MCP Servers — plug into Claude Code, Cursor, Codex & any MCP client',
    featureCluster: 'Cluster Management — nodes/shards/indices monitoring & ER dashboards',
    featureImportExport: 'Import/Export — batch migration up to million rows',
    featureSsh: 'SSH Tunnel & Proxy — plus AWS SSO/IAM enterprise auth',
    featureSupport: 'Priority Support',
    dockitDesc: 'NoSQL GUI · monitoring · PartiQL',
    sqlkitDesc: 'SQL editor · 70+ databases · history',
    agentDesc: 'AI coding agents access your databases',
    serverlessinsightDesc: 'Multi-cloud serverless infrastructure',
    downloadApps: 'Download apps',
    downloadAppsDesc: 'DocKit & SqlKit · macOS / Windows',
    devices: 'Devices',
    trustCancel: 'Cancel anytime, access till period end',
    trustFreeForever: 'Community stays free forever',
    trustTrial: 'Or try free for 7 days',
    openDockit: 'Open DocKit',
    openSqlkit: 'Open SqlKit',
    launching: 'Launching…',
    launchSteps: {
      subscription: 'Checking your subscription…',
      session: 'Securing your session…',
      opening: 'Opening {app}…',
    },
    appNotInstalled: {
      title: 'App Not Installed',
      description: '{app} does not appear to be installed on your device.',
      download: 'Go to Download Page',
      cancel: 'Cancel',
    },
  },
  notFound: {
    title: 'Not Found',
    description: 'The page you\'re trying to access could not be found',
    backHome: 'Back to Home',
  },
  devices: {
    title: 'Devices',
    description:
      'Your subscription can stay activated on up to 3 devices (1 during the free trial). Sign in from a new device and choose one to replace when the limit is reached.',
    slotUsage: '{used}/{limit} devices in use',
    empty: 'No devices yet. Devices appear here after you sign in from the desktop apps.',
    thisDevice: 'This device',
    statusRevoked: 'Revoked',
    activatedAt: 'Activated',
    lastSeenAt: 'Last active',
    neverSeen: 'Never',
    unbind: 'Unbind',
    selectTitle: 'Choose a device to unbind',
    selectDescription:
      'The removed device loses access immediately and shows up as revocable for at most 30 days offline. You can always sign in again from it while a slot is free.',
    confirmUnbind: 'Unbind Device',
    loadFailed: 'Failed to load devices',
    unbindFailed: 'Failed to unbind the device',
  },
}
